import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AuthScreen } from "@/components/auth/auth-screen";
import { ChoosePasswordForm } from "@/components/auth/choose-password-form";
import { useAdminPassword } from "@/hooks/use-admin-password";

const ResetPasswordPage = () => {
  const { email, token } = Route.useSearch();
  const mutation = useAdminPassword().resetPassword();

  return (
    <AuthScreen title="Reset your password">
      <p className="pb-6 text-sm text-content-muted">
        Choose a new password for your EO admin account.
      </p>

      <ChoosePasswordForm
        email={email}
        mutation={mutation}
        submitLabel="Reset password"
        successMessage="Your password was reset. You can log in now."
        token={token}
      />
    </AuthScreen>
  );
};

export const Route = createFileRoute("/_guest/reset-password/")({
  component: ResetPasswordPage,
  validateSearch: z.object({
    token: z.string().catch(""),
    email: z.string().catch(""),
  }),
});
